import { loadContent, CONTENT_TYPES } from '../../util/fetchutils';
import { parseQueryString } from '../../util/urlutils';

const SELECTORS = {
  PRODUCT_NAV: '.product-detail__nav-row__nav',
};
export default async () => {
  const navContainer = document.querySelector(SELECTORS.PRODUCT_NAV);

  if (navContainer && navContainer.getAttribute('initialized') !== 'true') {
    const { hash } = window.location;

    if (hash && hash.length && hash.indexOf('pos=') >= 0 && navContainer) {
      const { content, type } = await loadContent(navContainer, null, parseQueryString(hash));

      if (type === CONTENT_TYPES.TEXT) {
        navContainer.innerHTML = content;
      }
    }

    navContainer.setAttribute('initialized', 'true');
  }
};
